var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CC0511",
  fillRule: "evenodd",
  d: "M1.367 10h9.266L6 1.998zm0 1a1 1 0 0 1-.865-1.501l4.632-8.002a1 1 0 0 1 1.731 0l4.633 8.002A1 1 0 0 1 10.633 11z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CC0511",
  d: "M6.5 7.5h-1V4.25h1zM5.375 8.625a.625.625 0 1 1 1.25 0 .625.625 0 0 1-1.25 0"
})));
export default SvgWarning;